const EricCarleDisneyMobile = ({ width, fillColor = "#ffffff" }) => {
    return (
        <div className={`eric-carle-disney-mobile-icon h-auto`}>
            {/* Mobile-optimized SVG content will be added here */}
            <svg
    xmlns="http://www.w3.org/2000/svg"
    width="112"
    height="122"
    fill="none"
    viewBox="0 0 112 122"
  >
    <g clipPath="url(#clip0_11026_97826)">
      <path
        fill="#000"
        d="M34.818 46.656h-.537v-.224h2.227v.224h-.58l.723 2.092h.016l.79-2.092h-.583v-.224h2.297v.224h-.584l.708 2.092h.016l.76-2.092h-.535v-.224h1.355v.224h-.537l-1.342 3.514h-.236l-1.194-3.204-1.228 3.204h-.223zM43.703 48.256c0 .873 0 1.692-.776 1.692-.777 0-.773-.819-.773-1.692 0-.872 0-1.69.773-1.69.772 0 .776.82.776 1.69m1.161 0c0-1.102-.796-1.914-1.937-1.914s-1.937.812-1.937 1.914c0 1.17.782 1.914 1.937 1.914 1.14 0 1.937-.811 1.937-1.914M45.372 49.857h.538v-3.201h-.538v-.223h.464c.377 0 .765-.017 1.146-.046v.601h.014c.148-.378.523-.646.94-.646.47 0 .715.326.715.752 0 .305-.148.499-.485.499-.291 0-.455-.149-.455-.394 0-.217.016-.24.016-.35 0-.09-.037-.149-.143-.149-.43 0-.602 1.007-.602 1.585v1.571h.537v.226h-2.147zM48.96 49.856h.535v-4.88h-.535v-.222h.46c.381 0 .77-.013 1.147-.046v5.148h.538v.226H48.96zM54.354 48.256c0 .708-.053 1.6-.835 1.6-.574 0-.775-.52-.775-1.6 0-.886.035-1.6.775-1.6.782 0 .835.995.835 1.6m-.023 1.868c.447-.029.879-.035 1.607-.042v-.226h-.534v-5.148a14 14 0 0 1-1.147.046h-.462v.223h.536v1.9h-.015c-.172-.372-.567-.536-1.034-.536-1.098 0-1.67.909-1.67 1.915 0 1.035.475 1.914 1.607 1.914.405 0 .829-.08 1.097-.52h.015zM71.139 48.348c0 .872 0 1.69-.776 1.69-.775 0-.775-.818-.775-1.69 0-.873 0-1.691.775-1.691s.775.82.775 1.69m1.161 0c0-1.103-.796-1.915-1.937-1.915-1.14 0-1.937.812-1.937 1.915 0 1.17.783 1.914 1.937 1.914 1.141 0 1.937-.812 1.937-1.914M72.89 49.947h.536v-3.2h-.537v-.224h.537v-.456c0-.796.417-1.31 1.49-1.31.343 0 1.206.127 1.206.802 0 .365-.171.524-.46.524-.38 0-.477-.21-.477-.479 0-.297 0-.624-.32-.624-.327 0-.365.275-.365.556v.987h.617v.223H74.5v3.201h.617v.226h-2.228z"
      ></path>
      <path
        fill={fillColor}
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.35"
        d="M44.684 55.728v-3.392l-10.345.134V67.25H45.12l-.47-3.695-6.818.067.1-2.446h5.51l.066-2.995-4.232-.302.101-2.183zM46.174 52.132v15.394h4.505v-6.352l4.604 6.352 3.657-1.764-4.055-5.97 1.84-1.24.788-1.464.038-2.065-.826-1.426-1.953-.977-2.215-.488z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.35"
        d="m51.105 54.873-.2 3.792 2.027-.225 1.051-1.051.372-1.127-.58-1.089-.956-.3z"
      ></path>
      <path
        fill={fillColor}
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.35"
        d="M53.891 69.063v15.394h3.495v-6.352l3.57 6.352 2.836-1.765-3.145-5.97 1.427-1.238.612-1.465.029-2.065-.64-1.427-1.515-.976-1.718-.488z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.35"
        d="m57.715 71.805-.155 3.792 1.572-.225.816-1.052.288-1.126-.45-1.089-.741-.3z"
      ></path>
      <path
        fill={fillColor}
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.35"
        d="M59.653 55.962h5.144l.3 11.286h-5.444zM66.26 51.129 65.75 52.4l-.621 1.4-.957 1.072-.713.38H61.05l-1.156-.866-.814-.993-.789-2.54-.254-2.463.356-1.736.815-1.661.444-.458 1.287-.637 1.68-.28.865.306 1.426.942.942 1.247.585 1.28.178 1.622z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.35"
        d="m62.76 51.24-.172-.386h-.365l-.107.386-.193.365-.107.322.472.171h.321l.472-.086v-.343zM64.035 46.514h-.485l-.36.162-.174.273-.162.622v1.443l.227.842.183.413.473.262h.398l.248-.237.547-.994.2-1.604-.137-.572-.25-.286zM61.685 46.651l-.248-.218-.41-.056-.473.137-.187.212-.136.31-.175.572-.161.97v1.182l.186.41.311.124.51.112.423-.074.435-.162.298-.473.15-.808-.075-.908-.15-.72z"
      ></path>
      <path
        fill={fillColor}
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.35"
        d="m63.485 43.625.507-1.858.206-1.553.255-1.12.229-1.451-.331-.382-.359.153-.507.305-.305 1.12v4.074l.102.712zM60.94 43.711l.422-.07.058-1.454-.24-1.544-.24-1.654-.09-.584-.32-.598-.25-.125h-.389l-.32.236.07.779.195 1.112.764 1.752zM76.122 57.69l-.667-.389-1.447-.531-1.518.46-1.13.46-.812.976-.423 1.918.459 2.189 1.27 1.447 1.27.282 1.66-.529 1.338-.847 2.298 2.86-.67.882-2.154.953-2.753.176-2.365-.47-2.436-1.118-1.426-2.471-.763-2.965.212-3.036.953-2.26 1.447-1.835 1.695-.989 1.341-.564 1.871-.156 2.577.367 1.8.848.883 1.165zM42.313 74.15l-.582-.388-1.265-.531-1.326.46-.987.46-.71.976-.37 1.918.4 2.189 1.111 1.447 1.11.282 1.45-.529 1.17-.847 2.008 2.86-.586.882-1.882.953-2.406.176-2.066-.47-2.13-1.118-1.245-2.471-.666-2.965.185-3.036.832-2.26 1.265-1.835 1.48-.989 1.173-.564 1.635-.156 2.252.368 1.573.847.77 1.165zM64.226 84.031h6.633v-3.696h-3.036l.033-3.135.165-5.395v-2.921l-4.026.18zM78.483 84.03h-6.964V69.063h7.113v2.888l-4.01.067.099 2.772 3.366-.199.132 2.97-3.4.133-.098 3.069 3.762-.297zM47.231 83.964h-3.036l1.914-14.901 5.643.15 1.716 14.75h-3.4l-.636-4.274-1.574.084z"
      ></path>
      <path
        fill="#fff"
        stroke="#000"
        strokeMiterlimit="10"
        strokeWidth="0.35"
        d="m47.66 77.33 1.716.266-.264-5.083H48.09z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_11026_97826">
        <path fill="#fff" d="M33.233 37.133h45.534v47.474H33.233z"></path>
      </clipPath>
    </defs>
  </svg>
        </div>
    );
};

export default EricCarleDisneyMobile;